import { Page } from 'layouts/Page';
import { FC } from 'react';
import { EuDdpOrder } from 'components/EuDdpOrder';

export const EuDdpOrderPage: FC = () => {
	return (
		<Page title="EU DDP Order – EAS Dashboard">
			<EuDdpOrder />
		</Page>
	);
};
